import { GuestSelector } from "components/Header/components/GuestSelector"


export const Teste = () => {
    return (
        <>
            <GuestSelector />
        </>
    )
}